import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';

export const MarketHero = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  const { scrollYProgress } = useScroll({
    target: containerRef,
    offset: ["start start", "end start"]
  });

  const yText = useTransform(scrollYProgress, [0, 1], [0, 100]);
  const opacityText = useTransform(scrollYProgress, [0, 0.5], [1, 0]);
  const scaleImg = useTransform(scrollYProgress, [0, 1], [1, 1.1]);

  return (
    <section ref={containerRef} className="relative min-h-screen flex flex-col items-center justify-start pt-24 md:pt-32 overflow-hidden bg-background">

      <div className="container mx-auto px-4 relative z-10 flex flex-col items-center">
        {/* Top Icon */}
        <motion.div 
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          className="mb-8"
        >
          <img src="/Images/s2_client.webp" alt="Client Logo" className="h-12 w-auto object-contain" />
        </motion.div>

        {/* Main Heading */}
        <motion.h2 
          style={{ y: yText, opacity: opacityText }}
          className="font-heading font-extrabold text-center mb-8 md:mb-12 max-w-[90%] lg:max-w-5xl"
        >
          <span className="text-[#620131] text-[32px] leading-[40px] md:text-[42px] md:leading-[54px] lg:text-[52px] lg:leading-[67.6px] tracking-normal">
            Premium mono-carton solutions crafted with precision, innovation, and responsibility.<img src="/Images/about_leaves.webp" alt="Leaves" className="inline-block h-8 md:h-12 lg:h-16 w-auto align-middle ml-1 md:ml-2" />
          </span>
        </motion.h2>
      </div>

      {/* Hero Image Container - Full Width (90vw) */}
      <motion.div 
        style={{ scale: scaleImg }}
        className="relative z-10 w-[90vw] max-w-none mx-auto"
      >
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.2 }}
          className="rounded-[50px] overflow-hidden shadow-2xl shadow-primary/10 relative"
        >
         
          {/* Overlay Text */}
          <div className="absolute top-0 left-0 w-full h-full flex justify-center items-start pt-4 md:pt-10 z-10 pointer-events-none">
            <h1 
              className="font-heading font-extrabold text-transparent bg-clip-text text-center leading-none whitespace-nowrap opacity-20 mix-blend-overlay text-[40px] md:text-[100px] lg:text-[180px] xl:text-[220px]"
              style={{
                backgroundImage: 'linear-gradient(180deg, #FF4687 34.49%, rgba(255, 48, 157, 0.12) 71.55%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent'
              }}
            >
              PrintAura
            </h1>
          </div>

          <img 
            src="/Images/markets/hero.webp" 
            alt="PrintAura Premium Packaging" 
            className="w-full h-auto object-cover relative z-0"
          />
        </motion.div>
      </motion.div>
    </section>
  );
};
